import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { SubstanceConversionFactor } from 'app/area/codetable/item/types-store';
import { createConversionFactorsId } from 'app/area/codetable/item/codetable-item-helpers';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export interface UoMFromProps extends ScreenPickerProps {
  categoryId: number;
  value: CodeComplexValue<number>;
  onChange: (value: CodeComplexValue<number>) => void;
  conversionFactor: SubstanceConversionFactor;
}

export const UoMFrom = (props: UoMFromProps) => {

  const { breadcrumbs, codetableOptions, loadCodetableOptions, categoryId, value, translation, validation, readOnlyConfig, onChange,
    conversionFactor } = props;

  const codetableId = codetableOptionsIds[ScreenPicker.uomFrom];

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, {
      ...loadOptionsParams,
      ...(isDefinedIncludingZero(categoryId) && { categoryId })
    });
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  const codeOptions = (!!codetableOptions[ScreenPicker.uomFrom] && codetableOptions[ScreenPicker.uomFrom].codes || []);
  const validationError = validation[createConversionFactorsId(ScreenPicker.uomFrom, conversionFactor?.uomConversionType?.value)];
  const finalValidation = { ...validationError, ...getDisabledValidation(value?.disabled, translation.selected_value_disabled) };
  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return <CodeSinglePicker
    id={ScreenPicker.uomFrom}
    label={translation.uom_from}
    valueItem={value}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions[ScreenPicker.uomFrom] && codetableOptions[ScreenPicker.uomFrom].fetching}

    translation={translation}

    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={finalValidation}

    extraFooterButton={extraFooterButton}
  />;
};
